module.exports = __webpack_public_path__ + "img/combination_fingerprint@2x.d45c7c8.jpg";